import { useEffect, useState } from "react";
import { Pagination, PaginationSectionWrapper } from "../../components/Pagination";
import { Loading } from "../../components/ui/loading";
import { ResourceLoadingError } from "../../components/ui/resource-loading-error";
import Workspace from "../../components/workspace";
import offeringService from "../../services/offering-service";
import Offerings from "./Offerings";

const OfferingsListContainer = ({ search = "", page, setPage }) => {
   const [offerings, setOfferings] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [errorMessage, setErrorMessage] = useState();
   const [rows] = useState(10);
   const [totalPages, setTotalPages] = useState(1);

   useEffect(() => {
      async function loadOfferings() {
         setIsLoading(true);
         try {
            const fetchResult = await offeringService.getOfferings({ page, rows, search });
            setOfferings(fetchResult.data);
            setTotalPages(fetchResult.totalPages);
         } catch (error) {
            setErrorMessage(error.message);
         } finally {
            setIsLoading(false);
         }
      }
      loadOfferings();

      return () => {
         setErrorMessage(null);
      };
   }, [page, rows, search]);

   if (isLoading) return <Loading />;
   if (errorMessage) return <ResourceLoadingError error={errorMessage} />;

   return (
      <Workspace.List>
         <Offerings offeringsList={offerings} />
         <PaginationSectionWrapper>
            {offerings.length ? <Pagination setPage={setPage} page={page} totalPages={totalPages} /> : ""}
         </PaginationSectionWrapper>
      </Workspace.List>
   );
};

export default OfferingsListContainer;
